import {useMemo} from 'react';
import {useConnections} from './useConnections';

/**
 * Returns the first connection found with a specific user
 * @param {Number} userId User Id
 * @returns {object} Connection
 */
export function useConnection(userId) {
    const connections = useConnections();

    return useMemo(() => {
        return connections.find(con => con.id == userId);
    }, [connections, userId]);
}
